///<reference path="../../../../../typings/index.d.ts"/>
///<reference path="../../baseClasses/dataMaintenance.interface.ts"/>



module Meevo.Components.Controls {

    export enum ProgressBarViewTypesEnum {
        numeric = 1,
        percentage = 2
    }

    export interface IRatingWidgetListItem {
        label: string;
        value: number;
        percent: number;
    }

    interface IRatingRow {
        RatingCount: number;
        Rating?: number;
    }

    interface IRatingWidgetComponentScope extends ng.IScope {
    }

    class MeevoRatingWidgetComponent implements ng.IComponentController {

        static $inject = [
            '$scope',
            'meevo.components.common.DataService',
            '$translate',
        ];

        public totalCount: number;

        // --- scope ---
        public maxValue?: number;
        public data: IRatingWidgetListItem[];
        public criteria?: any;
        public url?: string;
        public dataMapFn?: (data: any[]) => IRatingWidgetListItem[];
        public viewtype: ProgressBarViewTypesEnum;

        // --- end scope ---

        get asyncStrategyAllowed(): boolean {
            return typeof this.url === 'string';
        }

        constructor(private $scope: IRatingWidgetComponentScope,
                    private dataService: Meevo.Components.BaseClasses.IDataService,
                    private $translate: angular.translate.ITranslateService) {
            this.totalCount = 0;
        }

        private initWatchers() {
            if (typeof this.criteria !== 'undefined') {
                this.$scope.$watch(() => this.criteria, _.debounce(() => {
                    this.preloadData();
                }, 500), true);
            }

            this.$scope.$watch(() => this.data, () => {
                this.initData();
            }, true);
        }

        private initData() {
            if (typeof this.maxValue === 'undefined') {
                this.maxValue = Math.max(
                    ...this.data.map(row => row.value)
                )
            }
            this.totalCount = this.data.reduce((count, row) => count + row.value, 0);
            this.data.forEach(row => {
                row.percent = Math.round(row.value / this.totalCount * 100);
                row.percent = _.isNaN(row.percent) ? 0 : row.percent;
            });
        }

        private preloadData() {
            let data = {
                criteria: this.criteria,
            };

            return this.dataService.customMethodData(this.url, 'POST', data).then(response => {
                this.data = typeof this.dataMapFn === 'function' ? this.dataMapFn(response.data) : response.data;
                this.initData();
            })
        }

        public $onInit() {
            this.initWatchers();

            if (this.data.length > 0) {
                this.initData();
            } else if (this.asyncStrategyAllowed) {
                this.preloadData();
            }
        }

        public getValue(item: IRatingWidgetListItem) {
            return this.viewtype === ProgressBarViewTypesEnum.numeric ? item.value : `${item.percent}% ${item.value} ${this.$translate.instant(item.value === 1 ? 'LABEL_REVIEW' : 'LABEL_REVIEWS').toLowerCase()}`;
        }

        public getAverageValue(value: IRatingRow[]): string {
            if (!(value instanceof Array && value.length > 0)) {
                return '';
            }

            let count = 0;
            let allAnswers = 0;

            value.forEach((element) => {
                if (element.Rating && element.Rating != 0) {
                    count += element.Rating * element.RatingCount;
                    allAnswers += element.RatingCount;
                }
            });
            let rating = count / allAnswers;

            // New rating calculation rounds down to the nearest 0.25 instead of 0.5
            rating = Math.floor(rating * 4) / 4;
            rating = isNaN(rating) ? 0 : rating;

            let returnedResponses: number = value
                .filter(row => typeof row.Rating === 'number')
                .reduce((res, current: IRatingRow) => {
                    res += current.RatingCount;

                    return res;
                }, 0);
            let sentResponses: number = value
                .reduce((res, current: IRatingRow) => {
                    res += current.RatingCount;

                    return res;
                }, 0);


            return this.$translate.instant('LABEL_RATING_TILE_HEADER', {
                rating,
                returnedResponses,
                sentResponses
            })
        }
    }

    angular.module('meevo.components.controls')
        .component('meevoRatingWidgetComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/rating-widget/rating-widget.component.html',
            controller: MeevoRatingWidgetComponent,
            controllerAs: '$ctrl',
            bindings: {
                maxValue: '<?',
                data: '<',
                average: '<',
                url: '@?',
                criteria: '<?',
                dataMapFn: '<?',
                viewtype: '<'
            }
        });
}
